import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { trackScrollDepth } from '../../Utils/Analytics'

export const SCROLL_DEPTH_THRESHOLDS = [25, 50, 75, 90]

const percentScrolled = () => {
  const doc = document.documentElement
  const scrollable = doc.scrollHeight - doc.clientHeight
  return scrollable <= 0 ? 0 : ((window.scrollY || doc.scrollTop) / scrollable) * 100
}

// Reports each milestone once per route. GA4's own scroll measurement only fires on a hard
// load, so without this every client-side navigation would look unscrolled. The router does
// not scroll to top on navigation, so milestones already below the carried-over position are
// seeded as fired: only depth the visitor actually reaches on the new route counts.
export const ScrollDepthTracker = () => {
  const { pathname } = useLocation()
  const fired = useRef<Set<number>>(new Set())

  useEffect(() => {
    const startAt = percentScrolled()
    fired.current = new Set(SCROLL_DEPTH_THRESHOLDS.filter((t) => startAt >= t))

    const onScroll = () => {
      const percent = percentScrolled()
      if (percent <= 0) return
      for (const threshold of SCROLL_DEPTH_THRESHOLDS) {
        if (percent >= threshold && !fired.current.has(threshold)) {
          fired.current.add(threshold)
          trackScrollDepth(threshold)
        }
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [pathname])

  return null
}
